// ManageMacros.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function ManageMacros() {
    return (
        <PageLayout title="Manage Macros" subtitle="Manage Macros overview">
            <div className="container flex col box-container">
                {/* <div className="box">Manage Macros</div> */}
            </div>
        </PageLayout>   
    );
}

export default ManageMacros;
